import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationAssociationIdHelper.component.html')
})
export class RegistrationAssociationIdHelperDialog {

    constructor(@Inject(MatDialogRef<RegistrationAssociationIdHelperDialog>) public dialogRef: MatDialogRef<RegistrationAssociationIdHelperDialog>) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }
}
